// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__tVx6z","toggle":"styles_toggle__1xw86","preview":"styles_preview__3Me00"};